<template>
<div class="page left">
  
  <table>
      <tr><td class="title">名</td><td  class="value"><input id="name" value="vaauth"/></td></tr>
      <tr><td>值</td><td><input id="value" value="" /></td></tr>
      <tr><td></td><td><input value="get" type="button" @click="get();"/></td></tr>
      <tr><td></td><td><input value="set" type="button" @click="set();"/></td></tr>
    </table>
    <div class="page__bd">
        <article class="weui-article">
                    <p>
                      <img src='../assets/logo_zm_zmxcl.gif' alt="logo"/>
                    </p>
            <h1>众敏经管云</h1>
            <section>
                <h2 class="title">众敏颂</h2>
                <section>
                    <p>
                      洗车上云就找众敏，全程可视账目清；
                    </p>
                    <p>
                      合作共建稳定运营，智能合约放宽心。123
                    </p>
                      <!--
                    <p>
                      <img src='../assets/logo_zm_omc.png' alt="logo"/> 
                    </p>-->
                </section>
                
                <h2 class="title">选择您要管理的商户</h2>
               
                    <p>您没有无任何商户的权限，可联系众敏获得权限。</p>
                </section>

                <h2>敏行致远</h2>
                <h3>Song of PCCS</h3>
               
        </article>
    </div>
    <div id="warnToast" style="display: none;">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
            <i class="weui-icon-warn weui-icon_toast"></i>
            <p class="weui-toast__content">获取数据失败</p>
        </div>
    </div>
  </div>
</template>

<script>

function CCookie()
{
  this.SetCookie = setCookie;
  this.GetCookie = getCookie;
  this.DelCookie = deleteCookie;
}
function getExpDate(days, hours, minutes) 
{
    var expDate = new Date( );
    if (typeof days == "number" && typeof hours == "number" && 
        typeof hours == "number") 
    {
        expDate.setDate(expDate.getDate( ) + parseInt(days));
        expDate.setHours(expDate.getHours( ) + parseInt(hours));
        expDate.setMinutes(expDate.getMinutes( ) + parseInt(minutes));
        return expDate.toGMTString( );
    }
}
   
// utility function called by getCookie( )
function getCookieVal(offset) 
{
    var endstr = document.cookie.indexOf (";", offset);
    if (endstr == -1) 
    {
        endstr = document.cookie.length;
    }
    return unescape(document.cookie.substring(offset, endstr));
}
   
// primary function to retrieve cookie by name
function getCookie(name) 
{
    var arg = name + "=";
    var alen = arg.length;
    var clen = document.cookie.length;
    var i = 0;
    while (i < clen) 
    {
        var j = i + alen;
        if (document.cookie.substring(i, j) == arg) 
        {
            return getCookieVal(j);
        }
        i = document.cookie.indexOf(" ", i) + 1;
        if (i == 0) break; 
    }
    return "";
}

// store cookie value with optional details as needed
function setCookie(name, value, expires, path, domain, secure) 
{
  console.log(name,value,document.cookie);
    document.cookie = name + "=" + escape (value) +
        ((expires) ? "; expires=" + expires : "") +
        ((path) ? "; path=" + path : "; path=/") +
        ((domain) ? "; domain=" + domain : "") +
        ((secure) ? "; secure" : "");
  console.log(name,value,document.cookie);
     
}
   
// remove the cookie by setting ancient expiration date
function deleteCookie(name,path,domain) 
{
    if (getCookie(name)) {
        document.cookie = name + "=" +
            ((path) ? "; path=" + path : "") +
            ((domain) ? "; domain=" + domain : "") +
            "; expires=Thu, 01-Jan-70 00:00:01 GMT";
    }
}

/*
 * 定义全局变量g_CCookie
 */
var g_CCookie =null ;
if(!g_CCookie)
	g_CCookie = new CCookie();

export default{
  data(){
    return{

    }
  },
  mounted(){

  },
  methods:{
    get(n){
      var name = document.getElementById("name");

    console.log(name);

    var value = g_CCookie.GetCookie(name.value);

    document.getElementById("value").value = value;
    },
    set(n,v){
      var name = document.getElementById("name");
      var value = document.getElementById("value");

      console.log(name,value);

      var value = g_CCookie.SetCookie(name.value,value.value);

    }
  }
}


</script>





// WEBPACK FOOTER //
// src/views/test.vue